<template>
	<div class="panel-group" id="accordion" role="tablist" aria-multiselectable="true">

		<div v-for="office in offices" class="panel panel-default">
			<div class="panel-heading d-flex align-items-center justify-content-between" role="tab" id="heading1" style="position:relative;min-height: 100px;">
				<h5 class="panel-title mb-0" style="width: 100%;">
					<a class="collapsed pl-5" role="button" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + office.id" aria-expanded="false" aria-controls="collapse1" :ref="'main'+office.id" style="min-height: 85px" @click="changeCollapseOpen(office.id)">
						<span style="font-size: 12px;">{{ getLocaleProperty(office.country.name, locale) + " - " + getLocaleProperty(office.city, locale) }}</span>
						<img class="icon-image" :src="getIcon(office)" alt="" style="max-height: 44px; position: absolute;right: 0;top: 2px;">
						<div style="background-image: linear-gradient(to right, #0575E6, #00DA79);color: #fff;position:absolute;bottom: 0;left: 0;width: 100%;text-transform: none;font-size: 13px;font-weight:bold;padding: .1rem 0 .1rem .75rem;" :ref="office.id">
							<span>{{ translations.partners_name }}:</span> {{ office.name['sk'] }}
						</div>
					</a>
				</h5>
			</div>
			<div :id="'collapse' + office.id" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading1">
				<div class="panel-body pl-0 pr-0">
					<div class="table-responsive">
						<table class="table">
							<tbody>
							<tr>
								<td>{{ translations.partners_name }}:</td>
								<td>{{ getLocaleProperty(office.name, locale) }}</td>
							</tr>
							<tr>
								<td>{{ translations.partners_address}}:</td>
								<td>{{ getLocaleProperty(office.street, locale) + ", " + getLocaleProperty(office.city, locale) }}</td>
							</tr>
							<tr>
								<td>{{ translations.partners_phone }}:</td>
								<td><a :href="'tel:'+office.phone_1">{{ office.phone_1 }}</a></td>
							</tr>
							<tr>
								<td>Email:</td>
								<td><a :href="'mailto:'+office.email">{{ office.email }}</a></td>
							</tr>
							<tr>
								<td>Web:</td>
								<td>
									<a v-if="office.web['sk'] !== null && office.web['sk'] !== ''" :href="getWebLink(office)" target="_blank">{{ office.web["sk"] }}</a>
								</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
	name: "Accordion",
	props: ['locale', 'translations'],
	computed: {
		...mapGetters(['offices']),
	},
	data() {
		return {
			collapseOpen: true,
		}
	},
	methods: {
		getIcon(office) {
			let icon = "";

			if (office.dental_technology_type && office.anesthetic_technology_type) {
				icon = "stomatologicka-dychacia.png";
			} else if (office.dental_technology_type) {
				icon = "stomatologicka-technika.png"
			} else if (office.anesthetic_technology_type) {
				icon = "anesteticka-a-dychacia-technika.png";
			}

			return "/assets/icons/" + icon;
		},
		getAddress(office) {
			let hasAddress = typeof office !== 'undefined' && typeof office.address !== 'undefined' && office.address[this.locale] !== 'undefined';

			return hasAddress ? office.address[this.locale] : '';
		},
		getLocaleProperty(object, locale) {
			if (typeof object[locale] === "undefined") {
				return object["sk"];
			} else {
				return object[locale];
			}
		},
		getWebLink(office) {
			return office.web['sk'];
		},
		changeCollapseOpen(id) {
			// this.collapseOpen = !this.collapseOpen
			if(this.$refs['main'+id][0].style.minHeight !== '85px') {
				setTimeout(() => {
					this.$refs['main'+id][0].style.minHeight = '85px'
					this.collapseOpen = !this.collapseOpen
					this.$refs[id][0].style.display='block'
				}, 150)
			} else {
				this.$refs['main'+id][0].style.minHeight = 'auto'
				this.collapseOpen = !this.collapseOpen
				this.$refs[id][0].style.display='none'
			}
		}
	}
}
</script>
